export enum STORAGE_KEYS {
  NavCollapsed = 'nav_collapsed',
  LegacyEnvSettings = 'legacy_env_settings',
  LodgementTableFilters = 'lodgement_table_filters',
}

interface IStorageOptions {
  sessionOnly?: boolean;
}

interface IStoredItem<T> {
  value: T;
}

export function saveStorageItem<T>(key: STORAGE_KEYS, value: T, options?: IStorageOptions): void {
  const storage = options?.sessionOnly ? sessionStorage : localStorage;
  const item: IStoredItem<T> = {
    value,
  };
  storage.setItem(key, JSON.stringify(item));
};

export function getStorageItem<T>(key: STORAGE_KEYS, options?: IStorageOptions): T | null {
  const storage = options?.sessionOnly ? sessionStorage : localStorage;
  const item = storage.getItem(key);
  if (item) {
    try {
      const parsedItem: IStoredItem<T> = JSON.parse(item);
      return parsedItem.value;
    } catch (error) {
      return null;
    }
  }
  return null;
}

export function removeStorageItem(key: STORAGE_KEYS, options?: IStorageOptions): void {
  const storage = options?.sessionOnly ? sessionStorage : localStorage;
  storage.removeItem(key);
};